// extracted by mini-css-extract-plugin
export var actionButton = "_cv-0";
export var attachmentLine = "_cv-1";
export var fileInput = "_cv-2";
export var fileUploadWrapper = "_cv-4";
export var footer = "_cv-3";
export var modalContent = "_cv-5";
export var paperclip = "_cv-6";
export var quillEditor = "_cv-7";